export const eventsPermission = 'ROLE_EVENT_SHOW';
export const delictsPermission = 'ROLE_DELICT_SHOW';
export const tasksPermission = 'ROLE_TASK_SHOW';
export const employeesPermission = 'ROLE_EMPLOYEE_SHOW';
export const ticketsPermission = 'ROLE_TICKET_SHOW';
export const dogsPermission = 'ROLE_DOG_SHOW';
export const bicyclesPermission = 'ROLE_BICYCLE_SHOW';
export const mapPermission = 'ROLE_MAP_SHOW';
export const hrMyPlansPermission = 'ROLE_HR_MY_PLAN_SHOW';
export const hrMyPermission = 'ROLE_HR_MY_SHOW';
export const hrOverviewsPermission = 'ROLE_HR_OVERVIEW_SHOW';
export const hrRequestsPermission = 'ROLE_HR_REQUEST_SHOW';
export const hrWorkTimesPermission = 'ROLE_HR_WORK_TIME_SHOW';
export const hrTemplatesPermission = 'ROLE_HR_TEMPLATE_SHOW';
export const hrDayplansPermission = 'ROLE_HR_DAYPLAN_SHOW';
export const hrShiftsPermission = 'ROLE_HR_SHIFT_SHOW';
export const hrWorkPositionsPermission = 'ROLE_HR_WORK_POSITION_SHOW';
export const workDayTypesPermission = 'ROLE_HR_WORK_DAY_TYPES_SHOW';
export const warehouseInventoryCardsPermission = 'ROLE_WAREHOUSE_INVENTORY_CARD_SHOW';
export const warehouseProtocolsPermission = 'ROLE_WAREHOUSE_PROTOCOLS_SHOW';
export const operationalWarehousePermission = 'ROLE_OPERATIONAL_WAREHOUSE_LIST';
export const operationalWarehouseOwnListPermission = 'ROLE_OPERATIONAL_WAREHOUSE_OWN_LIST';
export const operationalWarehouseRequestListPermission = 'ROLE_OPERATIONAL_WAREHOUSE_REQUEST_LIST';
export const operationalWarehouseRequestDeclinePermission = 'ROLE_OPERATIONAL_WAREHOUSE_REQUEST_DECLINE';
export const tripsPermission = 'ROLE_TRIP_SHOW';
export const wantedPermission = 'ROLE_WANTED_SHOW';
export const repairsPermission = 'ROLE_REPAIR_SHOW';
export const reportsPermission = 'ROLE_REPORT_SHOW';
export const dictionariesPermission = 'ROLE_DICTIONARY_SHOW';
export const historyPermission = 'ROLE_HISTORY_SHOW';
export const administrationPermission = 'ROLE_ADMINISTRATION_SHOW';



// WEBPACK FOOTER //
// ./src/permissions.ts